import * as React from "react";
import * as _ from "lodash";
import { FileTable } from "./FileTable";
import "./FileBrowser.scss";
import { Button, Classes } from "../externals";
import { CustomLabel } from "../CustomLabel";
import { StatusProxy } from "../StatusProxy";
export default class FileBrowser extends React.Component {
    constructor(props) {
        super(props);
        this.filterElements = () => {
            let filteredElements = this.props.elements;
            let filterStringWritten = this.state.filterString;
            if (this.state.filterString != "") {
                filteredElements = filteredElements.filter(function (element) {
                    return (_.toLower(element.type).includes(filterStringWritten) ||
                        _.toLower(element.name).includes(filterStringWritten) ||
                        _.toLower(element.size).includes(filterStringWritten) ||
                        _.toLower(element.lastModifiedDate).includes(filterStringWritten));
                });
            }
            let filterStringChosen = _.toLower(this.state.types[this.state.filterType]);
            if (filterStringChosen != "all") {
                if (filterStringChosen.includes("*")) {
                    filteredElements = filteredElements.filter(function (element) {
                        return element.name.match(new RegExp("^" +
                            filterStringChosen
                                .replace(/[.+?^${}()|[\]\\]/g, "\\$&")
                                .replace(/[*]/g, ".*") +
                            "$"));
                    });
                }
                else {
                    filteredElements = filteredElements.filter(function (element) {
                        return (_.toLower(element.type).includes(filterStringChosen) ||
                            _.toLower(element.name).includes(filterStringChosen) ||
                            _.toLower(element.size).includes(filterStringChosen) ||
                            _.toLower(element.lastModifiedDate).includes(filterStringChosen));
                    });
                }
            }
            if (this.state.sorting != 0) {
                filteredElements.sort(this.propComparator(this.state.sortedColumn, this.state.sorting));
            }
            return filteredElements;
        };
        this.handleFilterClean = () => {
            this.setState({
                filterString: "",
                filterType: 0,
            });
        };
        this.handleFilterChange = (e) => {
            const newFilterString = _.toLower(e.target.value);
            this.setState({
                clickedRow: -1,
                fileName: "",
                filterString: newFilterString,
            });
        };
        this.handleLocationClick = (id) => {
            this.setState({
                clickedRow: -1,
            });
            this.props.onClickedLocation && this.props.onClickedLocation(id);
        };
        this.handleRowClick = (id) => {
            if (id == this.state.clickedRow) {
                this.setState({
                    clickedRow: -1,
                    fileName: "",
                });
            }
            else {
                this.setState({
                    clickedRow: id,
                    fileName: this.getFileName(id),
                });
            }
        };
        this.handleDoubleClick = (str) => {
            if (typeof this.props.navigateDirectory !== "undefined") {
                this.props.navigateDirectory(str);
                this.setState({
                    clickedRow: -1,
                    fileName: "",
                });
            }
        };
        this.handleHeaderClick = (e) => {
            const sortedColumn = e.target.id;
            const sorting = this.state.sorting === 0 || this.state.sorting === 2 ? 1 : 2;
            this.setState({
                sortedColumn: sortedColumn,
                sorting: sorting,
            });
        };
        this.handleTypeChange = (e) => {
            const newFilterString = _.toLower(this.state.types[e.target.value]);
            if (newFilterString != "all") {
                this.setState({
                    clickedRow: -1,
                    fileName: "",
                    filterType: e.target.value,
                });
            }
            else {
                this.setState({
                    filterType: 0,
                });
            }
        };
        this.handleInputChange = (e) => {
            this.setState({
                clickedRow: -1,
                fileName: e.target.value,
            });
        };
        this.getFileName = (id) => {
            const filteredElements = this.filterElements();
            let fullFileName = "";
            if (this.props.hasLocations) {
                fullFileName =
                    id != -1 &&
                        filteredElements.hasOwnProperty(id) &&
                        filteredElements[id] != undefined
                        ? filteredElements[id].name
                        : "";
            }
            else if (id != -1 &&
                filteredElements.hasOwnProperty(id) &&
                filteredElements[id] != undefined) {
                if (typeof filteredElements[id].path !== "undefined") {
                    fullFileName = filteredElements[id].path;
                }
                else {
                    fullFileName = filteredElements[id].name;
                }
            }
            else {
                fullFileName = this.props.currentPath;
            }
            return typeof fullFileName !== "undefined" ? fullFileName : "";
        };
        this.buildBrowseTable = (elements) => {
            const { elementsStatus, elementsError } = this.props;
            return (React.createElement(StatusProxy, { status: elementsStatus, error: elementsError },
                React.createElement(FileTable, { elements: elements, rootPaths: this.props.rootPaths, hasLocations: this.props.hasLocations, clickedLocation: this.props.clickedLocation, clickedRow: this.state.clickedRow, filterString: this.state.filterString, sortedColumn: this.state.sortedColumn, sorting: this.state.sorting, onFilterClean: this.handleFilterClean, onFilterChange: this.handleFilterChange, onClickedLocation: this.handleLocationClick, onClickedRow: this.handleRowClick, onDoubleClick: this.handleDoubleClick, onClickedHeader: this.handleHeaderClick })));
        };
        let knownTypes = ["all"];
        for (let i = 0; i < this.props.extensions.length; i++) {
            if (this.props.extensions[i].includes("*")) {
                knownTypes.push(this.props.extensions[i]);
            }
            else {
                knownTypes.push("." + this.props.extensions[i]);
            }
        }
        this.state = {
            filterString: "",
            types: knownTypes,
            filterType: 0,
            clickedRow: -1,
            sortedColumn: "",
            sorting: 0,
            fileName: this.props.currentPath,
        };
    }
    componentDidMount() {
        if (this.props.currentPath && this.props.currentPath !== "") {
            for (let i = 0; i < this.props.elements.length; i++) {
                if (this.props.currentPath === this.getFileName(i)) {
                    this.setState({
                        clickedRow: i,
                    });
                    break;
                }
            }
        }
    }
    componentDidUpdate() {
        if (this.state.clickedRow === -1 && this.state.fileName !== "") {
            for (let i = 0; i < this.props.elements.length; i++) {
                if (this.state.fileName === this.getFileName(i)) {
                    this.setState({
                        clickedRow: i,
                    });
                    break;
                }
            }
        }
    }
    propComparator(property, sorting) {
        if (sorting === 1) {
            return function (a, b) {
                return a[property] < b[property]
                    ? 1
                    : b[property] < a[property]
                        ? -1
                        : 0;
            };
        }
        else {
            return function (a, b) {
                return a[property] > b[property]
                    ? 1
                    : b[property] > a[property]
                        ? -1
                        : 0;
            };
        }
    }
    render() {
        let filteredElements = this.filterElements();
        const path = this.props.rootPaths
            ? this.props.clickedLocation
                ? this.props.rootPaths[this.props.clickedLocation].relativeLocation
                : this.props.rootPaths[0].relativeLocation
            : "";
        const fileName = this.state.fileName;
        let options = [];
        for (let i = 0; i < this.state.types.length; i++) {
            options.push(React.createElement("option", { value: i.toString(), key: i }, this.state.types[i]));
        }
        let browserTable = this.buildBrowseTable(filteredElements);
        let inputs;
        if (this.props.hasLocations) {
            inputs = [
                React.createElement("input", { key: "path", className: `${Classes.INPUT} filebrowser-field tiny`, type: "text", value: path, "aria-label": "path-input", disabled: true }),
                React.createElement("input", { key: "name", className: `${Classes.INPUT} filebrowser-field small`, type: "text", value: fileName, "aria-label": "name-input", onChange: this.handleInputChange }),
            ];
        }
        else {
            inputs = (React.createElement("input", { key: "name", className: `${Classes.INPUT} filebrowser-field`, type: "text", value: fileName, onChange: this.handleInputChange }));
        }
        return (React.createElement("div", { className: "filebrowser" },
            browserTable,
            React.createElement("div", { className: "filebrowser-input" },
                React.createElement(CustomLabel, { text: "", inline: true, className: "filebrowser-label" },
                    React.createElement("span", { className: "filebrowser-span" }, "File:"),
                    inputs),
                React.createElement(Button, { className: "filebrowser-button", onClick: () => this.props.onAccept(path + fileName), disabled: this.props.isReadOnly }, "Accept")),
            React.createElement("div", { className: "filebrowser-input" },
                React.createElement(CustomLabel, { text: "", inline: true, className: "filebrowser-label" },
                    React.createElement("span", { className: "filebrowser-span" }, "Type:"),
                    React.createElement("div", { className: `${Classes.SELECT} filebrowser-field` },
                        React.createElement("select", { className: "filebrowser-select", value: this.state.filterType, onChange: (e) => {
                                this.handleTypeChange(e);
                            } }, options))),
                React.createElement(Button, { className: "filebrowser-button", onClick: () => this.props.onCancel() }, "Cancel"))));
    }
}
//# sourceMappingURL=FileBrowser.js.map